import { render, staticRenderFns } from "./Goldprice.vue?vue&type=template&id=018c2b7f&scoped=true&"
import script from "./Goldprice.vue?vue&type=script&lang=js&"
export * from "./Goldprice.vue?vue&type=script&lang=js&"
import style0 from "./Goldprice.vue?vue&type=style&index=0&id=018c2b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c2b7f",
  null
  
)

export default component.exports